var __default__ = {group:'m_11def92b',root:'m_f85678b6',image:'m_11f8ac07',placeholder:'m_104cd71f'};
export default __default__;